import { createFileRoute } from '@tanstack/react-router';

import { CategoriesCatalogPage } from '../../pages/catalog/categories/CategoriesCatalogPage';

export const Route = createFileRoute('/_auth/catalog/processes/$processId/categories/')({
  component: CategoriesCatalogPage,
});
